<template>
  <el-container>
    <el-aside :style="asideStyObj">
      <side-menu :is-collapse="isCollapse"></side-menu>
    </el-aside>
    <el-container>
      <el-header class="my-header" style="height: 50px;">
        <top-header @switchCollapse="handleSwitchCollapse"></top-header>
      </el-header>
      <el-main class="main">
        <slot></slot>
      </el-main>
      <div class="bottom">Copyright 粤ICP备XXXXXXXX号 © 2024-2099</div>
    </el-container>
  </el-container>
</template>
<script>

import SideMenu from "@/components/base/ui/SideMenu.vue";
import TopHeader from "@/components/base/ui/TopHeader.vue";

export default {
  name: 'UiMain',

  data() {
    const defaultConfig = {isCollapse: false};
    const userConfigJson = window.localStorage.getItem('userConfig');
    const userConfig = userConfigJson ? JSON.parse(userConfigJson) || defaultConfig : defaultConfig;
    return {
      isCollapse: userConfig.isCollapse
    };
  },
  components: {
    SideMenu,
    TopHeader
  },
  methods: {
    handleSwitchCollapse() {
      this.isCollapse = !this.isCollapse;
      const userConfig = {isCollapse: this.isCollapse};
      window.localStorage.setItem('userConfig', JSON.stringify(userConfig));
    },
  },
  computed: {
    asideStyObj() {
      return {width: this.isCollapse ? '64px' : '200px'};
    },
  },
};
</script>
<style scoped>

.app-title {
  margin: 26px;
  color: rgb(86, 101, 115);
  font-size: 22px;
  line-height: 27px;
}

.main {
  width: 100%;
  margin: 0 auto 0 auto;
  padding: 30px 30px 320px;
}

.my-header {
  border-bottom: #0a53be;
  margin-bottom: 18px;
  border-bottom: rgba(47, 63, 79, 0.16) 1px solid;
}

.bottom {
  margin: 0;
  background-color: #ffffff;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 15px;
  border-top: #e0e0e0 1px solid;
  color: #525252;
  font-weight: lighter;
  font-size: 12px;
}
</style>
